module.exports = __webpack_public_path__ + "static/mobile-app-5564ccfb245a62d18f08003f29750e4b.webp";